import React from 'react';
import Swal from 'sweetalert2';
import { deleteWithAuth } from '../../api/api';
import { API_URLS } from '../../api/apiConfig';

class ModalDeleteCleaning extends React.Component {
    static handleDelete = async (cleaning_id) => {
        const deleteApi = async (cleaning_id) => { // Definir deleteApi aquí como una función estática interna
            try {
                await deleteWithAuth(API_URLS.DELETE_CLEANING(cleaning_id));
            } catch (error) {
                console.error('Error deleting rule:', error);
                throw error;
            }
        };

        const result = await Swal.fire({
            title: '¡Cuidado!',
            text: 'Borrar una limpieza puede implicar cambios actuales en el panorama general de limpiezas',
            icon: 'info',
            confirmButtonText: `
                Borrar limpieza
            `,
            customClass: {
                confirmButton: 'btn btn-sm btn-primary',
              },
            showCancelButton: false,
        });

        if (result.isConfirmed) {
            try {
                Swal.showLoading();
                await deleteApi(cleaning_id); // Utilizar la función deleteApi aquí
                window.location.reload();
            } catch (error) {
                console.error('Error deleting cleaning:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error al eliminar una limpieza',
                    text: 'Hubo un problema al intentar eliminar una limpieza. Por favor, inténtalo de nuevo más tarde.',
                });
            }
        }
    };

    render() {
        return null;
    }
}

export default ModalDeleteCleaning;
